/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * @class QAS API Core
 */
import { qasGet } from './qasClient.js';

const QasClient = {
    qasGet,
};

export default QasClient;
